<template>
  <div>
    <div class="face-container" @click="photograph">
      <div v-if="videoError" class="face-tip flex flex-x">{{videoError}}</div>
      <div v-else class="face-tip">
        <div class="tip" v-if="needFaceDetect || (type==1||type==6)">
          <span v-if="faceModelLoaded" :class="detectTipClass">{{ detectTip }}</span>
          <span v-else-if="faceModelLoading">模型加载中，请稍候...</span>
          <span v-else>保持面部在框定范围内</span>
        </div>
        <div class="tip" v-else-if="needTongueDetect || (type==2||type==3)">
          <span v-if="tongueModelLoaded" :class="detectTipClass">{{ detectTip }}</span>
          <span v-else-if="tongueModelLoading">模型加载中，请稍候...</span>
          <span v-else>请将舌头靠近摄像头</span>
        </div>
        <div class="tip" v-else>请将舌头抵住上颚，尽量露出舌底</div>
        <div class="tip col" v-if="(needTongueDetect || type==2||type==3) && tongueModelLoaded">检测到舌头将自动拍摄</div>
        <div class="tip col" v-else-if="(needFaceDetect || type==1||type==6) && faceModelLoaded">检测到面部将自动拍摄</div>
        <div class="tip col" v-else>点击屏幕拍摄</div>
      </div>
      <div class="face-camera" :class="{
            'faceFrame':faceFrame==2
      }">
        <img v-if="faceFrame!==2" src="../../../images/face_bg.png" alt=" " class="face_bg"/>
        <div class="video">
          <canvas ref="canvas" style="display: none"></canvas>
          <canvas ref="previewCanvas" class="preview-canvas" :class="{
            'rotate90':rotate90==2,
            'rotate-90':rotate90==3,
            'rotate180':rotate90==4
          }"></canvas>
          <video ref="video" autoplay playsinline muted
                 style="position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;overflow:hidden;"></video>
        </div>
      </div>
      <div class="face-con"/>
    </div>
    <div class="loading flex flex-x flex-y" v-if="loading">
        <div class="loading-box">
          <div class="loading-icon">
            <van-loading />
            <div class="loading-ui">上传中</div>
          </div>
        </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="no_show">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/false.png" alt=" " class="icon-img"/>
                <div class="load-no">{{no_show}}</div>
                <div @click="previewFun">
                  <img src="../../../images/face1.png" alt=" " class="load-img" v-if="type==1"/>
                  <img src="../../../images/tongues.png" alt=" " class="load-img" v-else/>
                </div>
                <div class="again" @click="photoFun">重新检测</div>
              </div>
          </div>
      </div>
      <div class="loading black flex flex-x flex-y" v-if="explain">
          <div class="loading-box">
              <div class="load-bac">
                <img src="../../../images/status-ok.png" alt=" " class="icon-img"/>
                <div class="load-explain">{{explain}}</div>
              </div>
          </div>
      </div>
      <div v-if="dialog" class="loading black flex flex-x flex-y">
        <div class="loading-box">
            <div class="load-bac load-dialog">
              <div class="load-explain">光线太暗或舌伸太短，会影响检测结果，建议重拍</div>
              <div class="dialog-box flex">
                <div class="flex-1 dialog-user" @click="phokFun">使用照片</div>
                <div class="flex-1 dialog-again" @click="photoFun">重新拍摄</div>
              </div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
  import "./camera.scss";
  import { mapActions , mapMutations , mapState } from "vuex";
  import { ImagePreview } from 'vant';
  import cameraDetector from './cameraDetector.js';
  export default {
    name: "camera",
    mixins: [cameraDetector],
    data () {
      return {
        imgSrc: "",
        videoError:"",
        stream:null,
        rotate90:1,
        faceFrame:1
      };
    },
    props: ["type"],
    created: function () {
      let equipment = sessionStorage.equipment;
      if(equipment){
        equipment = JSON.parse(equipment);
        this.rotate90 = equipment.camera_rotation;
        this.faceFrame = equipment.face_frame;
      }
      if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
        this.startUpAndroidCamera ();
      } else {
        this.startUpWebCamera ();
      }
    },
    computed:{
      ...mapState('step',['show','loading','no_show','explain','dialog','errorImg']),
    },
    beforeDestroy(){
      if(this._rafId){
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
      if(this.stream){
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
    },
    methods: {
      phokFun(){
        this.phoFun({
          _this:this,
          type:this.$props.type
        })
      },
      previewFun(){
        ImagePreview([this.errorImg]);
      },
      // 启动H5摄像头
      startUpWebCamera () {
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia ({ audio: false, video: true }).then (stream => {
            this.stream = stream;
            const video = this.$refs["video"];
            if (!video) return;

            video.playsInline = true;
            video.muted = true;
            video.srcObject = stream;

            video.onloadeddata = () => {
              video.play().then(() => {
                const preview = this.$refs["previewCanvas"];
                if (preview && video.videoWidth) {
                  preview.width = video.videoWidth;
                  preview.height = video.videoHeight;
                }
                this.renderLoop();
              }).catch(() => {});
            };
            
          }).catch(err => {
            if (err.name === "NotAllowedError") {
                this.videoError = "用户拒绝了权限请求";
            } else if (err.name === "NotFoundError") {
                this.videoError = "未找到可用的摄像头";
            } else if (err.name === "NotSupportedError") {
                this.videoError = "此功能仅支持 HTTPS 环境，请在 HTTPS 环境下运行";
            } else {
                this.videoError = JSON.stringify(err);
            }
          });
        }
      },
      renderLoop () {
        const video = this.$refs["video"];
        const preview = this.$refs["previewCanvas"];
        if (!video || !preview || !this.stream) return;
        if (video.readyState >= video.HAVE_CURRENT_DATA) {
          const ctx = preview.getContext("2d");
          ctx.drawImage(video, 0, 0, preview.width, preview.height);
        }
        this._rafId = requestAnimationFrame(() => this.renderLoop());
      },
      // 启动安卓（设备端）摄像头
      startUpAndroidCamera () {
        window["ReactNativeWebView"].postMessage ("photo");
        window.obj = {};
        var _this = this;
        Object.defineProperty(window.obj, "url", {
          get: function () {
            return '';
          },
          set: function (newValue) {
            _this.axiosData({
              data:{
                photo:newValue,
                type:_this.$props.type
              },
              _this:_this
            })
          },
        });
      },

      photoFun(){
        this.againFun();
        // 混入提供的检测重置（存在则调用，不存在则跳过）
        if (this.resetDetection) {
          this.resetDetection();
        }
        if (sessionStorage && (sessionStorage.device === "android" && !sessionStorage.camera)) {
          this.startUpAndroidCamera ();
        }
      },

      // 拍照
      photograph () {
        if (this.loading) return;
        let video = this.$refs["video"];
        let canvas = this.$refs["canvas"];
        if (!video || !canvas || !video.videoWidth || !video.videoHeight) {
          if (this.needModelDetect) this.detectTip = '摄像头启动中，请稍候';
          return;
        }
        let ctx = canvas.getContext("2d");
        canvas.width = 1200;
        canvas.height = video.videoHeight * (canvas.width / video.videoWidth);
        ctx.drawImage(
            video,
            0,
            0,
            canvas.width,
            canvas.height
        );
        const image = canvas.toDataURL('image/jpeg');
        let degrees = 0;
        if(this.rotate90==2){
          degrees = 90;
        }else if(this.rotate90==3){
          degrees = -90;
        }else if(this.rotate90==4){
          degrees = 180;
        }
        let _this = this;
        this.rotateBase64Image(image, degrees).then((rotatedBase64) => {
          _this.axiosData({
            data:{
              photo:rotatedBase64,
              type:this.$props.type
            },
            _this:this
          })
        });
      },
      rotateBase64Image(base64Image, degrees) {
        if(degrees===0){
          return new Promise((resolve, reject) => {
            resolve(base64Image);
          });
        }else{
          const image = new Image();
          image.src = base64Image;

          return new Promise((resolve, reject) => {
            image.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              let outputWidth = image.width;
              let outputHeight = image.height;

              if (degrees === 90 || degrees === -90) {
                outputWidth = image.height;
                outputHeight = image.width;
              }

              if (degrees === 180) {
                outputWidth = image.width;
                outputHeight = image.height;
              }

              canvas.width = outputWidth;
              canvas.height = outputHeight;

              const x = canvas.width / 2;
              const y = canvas.height / 2;

              ctx.translate(x, y);
              ctx.rotate((degrees * Math.PI) / 180);
              ctx.translate(-image.width / 2, -image.height / 2);

              ctx.drawImage(image, 0, 0);

              const rotatedBase64 = canvas.toDataURL('image/jpeg', 0.9);
              resolve(rotatedBase64);
            };
            image.onerror = () => {
              reject(new Error("屏幕旋转失败！"));
            };
          });
        }
      },

      ...mapMutations ("step", ["againFun","phoFun"]),
      ...mapActions ("step", ["axiosData"])
    }
  };
</script>
